<div class="container-fluid">
  @if (isLoading) {
    <div class="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="loading-container">
                <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                <div class="text">Loading...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @else{
    <div class="row" *ngIf="!!currentJob && !isLoading" [@fadeInOut]>
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div *ngIf="currentJob?.run_cost && currentJob?.run_cost_type">
              <div style="display: flex; align-items: center; gap: 24px; padding: 10px 0;">
                <div>
                  <span style="color: #666; font-weight: 500; font-size: 0.9rem; text-transform: uppercase;">Run Cost</span>
                  <div style="font-size: 1.4rem; font-weight: 700; color: #1a1a1a;">
                    ${{currentJob?.run_cost?.toFixed(2) || "0.00"}}
                  </div>
                </div>

                <div style="width: 1px; height: 30px; background: #e0e0e0;"></div>

                <div>
                  <span style="color: #666; font-weight: 500; font-size: 0.9rem; text-transform: uppercase;">Iteration Cost</span>
                  <div style="font-size: 1.4rem; font-weight: 700; color: #1a1a1a;">
                    ${{ (currentJob?.run_cost / currentJob?.iterations)?.toFixed(2) || "0.00" }}
                  </div>
                </div>

                  <span 
                    nz-tooltip 
                    nzTooltipTitle="Estimate: Calculated using the job run time and resources used | Definite: Fetched from AWS showing the exact total cost"
                    style="
                      background: #fff7e6;
                      border: 1px solid #ffd591;
                      color: #fa8c16;
                      padding: 4px 12px;
                      border-radius: 6px;
                      font-size: 12px;
                      font-weight: 600;
                      cursor: help;
                      text-transform: uppercase;
                    ">
                    {{currentJob?.run_cost_type}}
                  </span>
                </div>
              <nz-divider></nz-divider>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-horizontal">
                  @for (category of getObjKeys(globalInfo); track category) {
                    <div>
                      <div class="row">
                        <h5 class="col-sm-9">{{category}}</h5>
                      </div>
                      @for (param of getObjKeys(globalInfo[category]); track param) {
                        <div class="form-group">
                          <label class="col-sm-5">{{param}}:</label>
                          @if (currentCosts) {
                            <span class="col-sm-6">{{globalInfo[category][param]}}</span>
                          }
                        </div>
                      }
                    </div>
                  }
                  <h4>Time Stepping</h4>
                  <div class="form-group">
                    <label class="col-sm-5">Sample interval:</label>
                    @if (currentCosts) {
                      <span class="col-sm-6">{{currentCosts.timeSample}}</span>
                    }
                  </div>
                  <div class="form-group">
                    <label class="col-sm-5">Number of Time Steps:</label>
                    @if (currentCosts) {
                      <span class="col-sm-6">{{currentCosts.timeSteps}}</span>
                    }
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-horizontal">
                  @if (blkInfo.length > 0) {
                    <div>
                      <h4>Iteration Blocks</h4>
                      <div class="form-group">
                        <mat-form-field class="col-sm-7">
                          <mat-label>Block Number</mat-label>
                          <mat-select [(ngModel)]="selectedBlk">
                            @for (blk of blkInfo; track blk; let number = $index) {
                              <mat-option [value]="blk">
                                {{number+1}}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      @for (category of getObjKeys(selectedBlk); track category) {
                        <div>
                          <div class="row">
                            <h5 class="col-sm-9">{{category}}</h5>
                          </div>
                          @for (param of getObjKeys(selectedBlk[category]); track param) {
                            <div class="form-group">
                              <label class="col-sm-5">{{param}}:</label>
                              @if (currentCosts) {
                                <span class="col-sm-6">{{selectedBlk[category][param]}}</span>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span class="foot-note"> * : parameter not specified in runfile </span>
    </div>
  }
</div>